export const STYLE_MAP = {
  default: {
    backgroundColor: '#F6F7F9',
    textColor: '#8E969B',
    activeTextColor: '#1E2E37',
    activeBlockColor: '#1E2E37',
    activeBackgroundColor: '#ffffff'
  },
  diablo: {
    backgroundColor: '#171c1f',
    textColor: '#797c7e',
    activeTextColor: '#cfcfd0',
    activeBlockColor: '#cfcfd0',
    activeBackgroundColor: '#101315'
  },
  colmo: {
    backgroundColor: '#1c1d20',
    textColor: '#a4a5a6',
    activeTextColor: '#B35336',
    activeBlockColor: '#B35336',
    activeBackgroundColor: '#151617'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-side-nav/style.js